import React from 'react';
import { arrayOf, bool, number, shape, string } from 'prop-types';
import { NUMERIC_TYPE } from '../../../utils/packagesUtils/constants';
import { formatPricingFactorValue } from '../../../utils/packagesUtils';
import BooleanPricingFactor from '../BooleanPricingFactor';
import NumberedPricingFactor from '../NumberedPricingFactor';
import PricingFactorLabel from '../PricingFactorLabel';

const PricingFactorRow = ({ name, rowData = [] }) => {
    if (!rowData.length) {
        return null;
    }

    return (
        <tr>
            <th>
                <PricingFactorLabel name={name}/>
            </th>
            {
                rowData.map(({ id, value, included, customized, packageId, type }) =>
                    (type === NUMERIC_TYPE && included) ?
                        <NumberedPricingFactor key={packageId} value={formatPricingFactorValue(value)}/> :
                        <BooleanPricingFactor key={packageId} id={id} included={included}
                            customized={customized} packageId={packageId}/>)
            }
        </tr>
    );
};

PricingFactorRow.propTypes = {
    name: string.isRequired,
    rowData: arrayOf(shape({
        id: number,
        value: number,
        included: bool,
        customized: bool,
        packageId: number,
        type: string
    }))
};

export default PricingFactorRow;
